import $ from 'jquery';
global.$ = global.jQuery = $;

const isDebug = false; //デバッグ
const __c__ = function (a) {
  if (isDebug) {
    console.log(a);
  }
};

const pow = Math.pow,
  sqrt = Math.sqrt,
  sin = Math.sin,
  cos = Math.cos,
  PI = Math.PI,
  c1 = 1.70158,
  c2 = c1 * 1.525,
  c3 = c1 + 1,
  c4 = ( 2 * PI ) / 3,
  c5 = ( 2 * PI ) / 4.5;
// x is the fraction of animation progress, in the range 0..1
function bounceOut(x) {
  const n1 = 7.5625,
    d1 = 2.75;
  if ( x < 1/d1 ) {
    return n1*x*x;
  } else if ( x < 2/d1 ) {
    return n1*(x-=(1.5/d1))*x + 0.75;
  } else if ( x < 2.5/d1 ) {
    return n1*(x-=(2.25/d1))*x + 0.9375;
  } else {
    return n1*(x-=(2.625/d1))*x + 0.984375;
  }
}
$.extend( $.easing,
  {
    def: 'easeOutQuad',
    swing: function (x) {
      return $.easing[$.easing.def](x);
    },
    easeInQuad: function (x) {
      return x * x;
    },
    easeOutQuad: function (x) {
      return 1 - ( 1 - x ) * ( 1 - x );
    },
    easeInOutQuad: function (x) {
      return x < 0.5 ?
        2 * x * x :
        1 - pow( -2 * x + 2, 2 ) / 2;
    },
    easeInCubic: function (x) {
      return x * x * x;
    },
    easeOutCubic: function (x) {
      return 1 - pow( 1 - x, 3 );
    },
    easeInOutCubic: function (x) {
      return x < 0.5 ?
        4 * x * x * x :
        1 - pow( -2 * x + 2, 3 ) / 2;
    },
    easeInQuart: function (x) {
      return x * x * x * x;
    },
    easeOutQuart: function (x) {
      return 1 - pow( 1 - x, 4 );
    },
    easeInOutQuart: function (x) {
      return x < 0.5 ?
        8 * x * x * x * x :
        1 - pow( -2 * x + 2, 4 ) / 2;
    },
    easeInQuint: function (x) {
      return x * x * x * x * x;
    },
    easeOutQuint: function (x) {
      return 1 - pow( 1 - x, 5 );
    },
    easeInOutQuint: function (x) {
      return x < 0.5 ?
        16 * x * x * x * x * x :
        1 - pow( -2 * x + 2, 5 ) / 2;
    },
    easeInSine: function (x) {
      return 1 - cos( x * PI/2 );
    },
    easeOutSine: function (x) {
      return sin( x * PI/2 );
    },
    easeInOutSine: function (x) {
      return -( cos( PI * x ) - 1 ) / 2;
    },
    easeInExpo: function (x) {
      return x === 0 ? 0 : pow( 2, 10 * x - 10 );
    },
    easeOutExpo: function (x) {
      return x === 1 ? 1 : 1 - pow( 2, -10 * x );
    },
    easeInOutExpo: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
        pow( 2, 20 * x - 10 ) / 2 :
        ( 2 - pow( 2, -20 * x + 10 ) ) / 2;
    },
    easeInCirc: function (x) {
      return 1 - sqrt( 1 - pow( x, 2 ) );
    },
    easeOutCirc: function (x) {
      return sqrt( 1 - pow( x - 1, 2 ) );
    },
    easeInOutCirc: function (x) {
      return x < 0.5 ?
        ( 1 - sqrt( 1 - pow( 2 * x, 2 ) ) ) / 2 :
        ( sqrt( 1 - pow( -2 * x + 2, 2 ) ) + 1 ) / 2;
    },
    easeInElastic: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 :
        -pow( 2, 10 * x - 10 ) * sin( ( x * 10 - 10.75 ) * c4 );
    },
    easeOutElastic: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 :
        pow( 2, -10 * x ) * sin( ( x * 10 - 0.75 ) * c4 ) + 1;
    },
    easeInOutElastic: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
        -( pow( 2, 20 * x - 10 ) * sin( ( 20 * x - 11.125 ) * c5 )) / 2 :
        pow( 2, -20 * x + 10 ) * sin( ( 20 * x - 11.125 ) * c5 ) / 2 + 1;
    },
    easeInBack: function (x) {
      return c3 * x * x * x - c1 * x * x;
    },
    easeOutBack: function (x) {
      return 1 + c3 * pow( x - 1, 3 ) + c1 * pow( x - 1, 2 );
    },
    easeInOutBack: function (x) {
      return x < 0.5 ?
        ( pow( 2 * x, 2 ) * ( ( c2 + 1 ) * 2 * x - c2 ) ) / 2 :
        ( pow( 2 * x - 2, 2 ) *( ( c2 + 1 ) * ( x * 2 - 2 ) + c2 ) + 2 ) / 2;
    },
    easeInBounce: function (x) {
      return 1 - bounceOut( 1 - x );
    },
    easeOutBounce: bounceOut,
    easeInOutBounce: function (x) {
      return x < 0.5 ?
        ( 1 - bounceOut( 1 - 2 * x ) ) / 2 :
        ( 1 + bounceOut( 2 * x - 1 ) ) / 2;
    }
  });

class Accordion {
  constructor(elm) {
    this.elm = elm;
    this.button = this.elm.querySelector(".accordion--btn");
    this.button.addEventListener('click', this.toggle.bind(this));
  }
  
  toggle() {
    const _elm = this.elm;
    const _class = _elm.classList.value;
    
    if(_class.indexOf('open') !== -1) {
      _elm.classList.remove('open');
      const offsetTop = _elm.offsetTop + _elm.offsetParent.offsetTop;
      window.scrollTo({top: offsetTop, behavior: 'smooth'});
    }else{
      _elm.classList.add('open');
    }
  }
}

class Koma {
  constructor(elm) {
    this.elm = elm;
    this.loop = this.elm.dataset.komaLoop !== null ? this.elm.dataset.komaLoop : false;
    this.loop = this.loop === "true";
    this.delay = this.elm.dataset.komaDelay !== null ? this.elm.dataset.komaDelay | 0 : 0;
    this.imgs = elm.querySelectorAll('div');
    this.imgLength = this.imgs.length ? this.imgs.length : 0;
    this.nowCount = 0;
    this.timer = 0;
    this.scrolled = false;
  }
  
  next() {
    const _this = this;
    const nowImg = _this.imgs[_this.nowCount];
    if (!nowImg) return;
    
    _this.imgs.forEach(function (img, index) {
      if(index === _this.nowCount) {
        img.style.opacity = 1;
      }else{
        img.style.opacity = 0;
      }
    });
  }
  
  delayStart(){
    const _this = this;
    const _delayTime = setTimeout(function(){
      clearTimeout(_delayTime);
      _this.start();
    }, _this.delay);
    
  }
  
  start() {
    const _this = this;
    const nowImg = _this.imgs[_this.nowCount];
    if (!nowImg) return;
    const time = nowImg.dataset.komaTime || 1000;
    
    _this.timer = setTimeout(function(){
      _this.nowCount++;
      
      if(_this.nowCount === _this.imgLength) {
        if(_this.loop) {
          _this.nowCount = 0;
          _this.next();
          _this.start();
        }else{
          _this.stop();
        }
      }else{
        _this.next();
        _this.start();
      }
    }, time);
  }
  
  stop() {
    __c__("stop");
  }
  
  scroll() {
    const _this = this;
    if(_this.scrolled) return true;
    
    let scrollY = window.scrollY;
    let windowHeight = window.innerHeight;
    let timing = windowHeight - (windowHeight / 5);
    let target = _this.elm;
    let rect = target.getBoundingClientRect();
    let offsetTop = scrollY + rect.top;
    
    if(scrollY + timing >= offsetTop){
      _this.delayStart();
      _this.scrolled = true;
    }
  }
}

class SetStoreContents {
  #maxDisplayNumber = 4;
  #closedStores = [];
  
  constructor(primary, secondary, region) {
    this.primary = primary;
    this.secondary = secondary;
    this.region = region;
  }
  
  getHTML(data) {
    let isClosed = false;
    const _region = this.region;
    for (let i = 0; i < this.#closedStores.length; i++) {
      if (data.name.indexOf(this.#closedStores[i]) !== -1) {
        isClosed = true;
      }
    }
    
    return `
    <div class="stores-box" data-store-closed="${isClosed}" data-store-original="${data.original}">
      <div class="stores--img"><img src="assets/img/thumb${data.id}_${_region}_stores.png" alt="${data.name}" width="320" height="320"></div>
      <p class="stores--name">${data.htmltext}</p>
      <div class="stores--btn"><a href="${data.url}" target="_blank"><img src="assets/img/btn_stores.png" alt="店舗情報" width="257" height="64"></a></div>
    </div>
    `;
  }
  
  setData(data) {
    const _this = this;
    const _len = data.length;
    
    let primaryHTML = "";
    let secondaryHTML = "";
    
    for (let i = 0; i < _len; i++) {
      if (i < _this.#maxDisplayNumber) {
        primaryHTML += _this.getHTML(data[i]);
      } else {
        if (_this.secondary !== null) {
          secondaryHTML += _this.getHTML(data[i]);
        }
      }
    }

    _this.primary.innerHTML = primaryHTML;
    if (_this.secondary !== null) {
      _this.secondary.innerHTML = secondaryHTML;
    }
  }
}

global._isSP = undefined;

_isSP = window.outerWidth < 829;

;(function() {
  const $window = $(window);
  const $html = $("html");
  const $body = $("body");
  const $main = $("#main");
  const $view = $("#view");
  
  const $menu = $("#menu");
  const $menuBtn = $("#btn_menu");
  const NavOpenClose = function () {
    if ($menu.hasClass("open")) {
      $menu.removeClass("open");
      $html.removeClass("is-modal");
    } else {
      $menu.addClass("open");
      $html.addClass("is-modal");
    }
  };
  $menuBtn.on('click', NavOpenClose);
  
  let windowInnerHeight = window.innerHeight;
  let isEventSetAnimation = true;
  let AnimationScroller = null;
  
  const AnimationStart = function ($container) {
    let _$wait = $container.find(".wait");
    _$wait.each(function () {
      const __$this = $(this);
      const __delay = __$this.data("delay") || 0;
      let __timeout = setTimeout(function () {
        __$this
          .removeClass("wait")
          .addClass("animation");
        clearTimeout(__timeout);
      }, __delay)
    });
    
    const _$swing = $container.find(".swing");
    _$swing.each(function () {
      const __$this = $(this);
      const __delay = __$this.data("delay") || 0;
      //console.log(__delay);
      let __timeout = setTimeout(function () {
        Swing(__$this);
        clearTimeout(__timeout);
      }, __delay)
    });
  };
  
  const SetAnimation = function (target) {
    if (_isSP && target.id === "view") {
      console.log('tet');
      return;
    }
    
    let $section = $(".waiting");
    const sectionLen = $section.length;
    let timing, mainHeight, mainTop;
    mainTop = 0;
    
    if (_isSP) {
      timing = windowInnerHeight - (windowInnerHeight / 5);
    } else {
      // $view
      timing = windowInnerHeight - (windowInnerHeight / 5);
    }
    
    if (sectionLen === 0) {
      isEventSetAnimation = false;
    } else {
      for (let i = 0; i < sectionLen; i++) {
        const $wait = $($section[i]);
        let offsetTop = $wait.offset().top;
        let targetPointCheck = null;
        
        targetPointCheck = $window.scrollTop() + timing >= offsetTop && $window.scrollTop() <= offsetTop;
        
        if (targetPointCheck) {
          let _delay = $wait.data("delay");
          if (_delay === void 0) {
            _delay = 0;
          }
          $wait.delay(_delay).queue(function () {
            const __$this = $(this);
            __$this.removeClass("waiting").addClass('animating');
            __$this.dequeue();
          });
        }
      }
    }
  };
  
  // メインのアニメーション
  const StartTopAnimation = function () {
    let _t = setTimeout(function () {
      
      // ScrollAnimatiopn
      AnimationScroller = function (event) {
        if (isEventSetAnimation) SetAnimation(event.currentTarget);
        _koma.forEach(function (element) {
          if (element.__komaInstance) {
            element.__komaInstance.scroll();
          }
        });
      };
      
      AnimationStart($("#kv"));
      
      $window.on("scroll", AnimationScroller);
      $view.on("scroll", AnimationScroller);
      
      clearTimeout(_t);
    }, 100);
  };
  StartTopAnimation();
  
  const _koma = window.document.querySelectorAll('.koma');
  _koma.forEach(function (element) {
    element.__komaInstance = new Koma(element);
  });
  
  const _accordions = window.document.querySelectorAll('.accordion');
  _accordions.forEach(function (element) {
    new Accordion(element);
  });
  
  // PAGETOP BUTTON
  const $kv = $("#kv");
  const $breadHead = $(".bread--head");
  const $pagetop = $(".btn--pagetop");
  const PageTopScroll = function(){
    if($window.scrollTop() > $kv.outerHeight() - $window.innerHeight() + $breadHead.outerHeight()){
      if(!$pagetop.hasClass("appear")){
        $pagetop.addClass("appear");
      }
    }else{
      if($pagetop.hasClass("appear")){
        $pagetop.removeClass("appear");
      }
    }
  };
  $window.on("scroll", PageTopScroll);
  
  const ViewTopScroll = function(){
    if($view.scrollTop() > $kv.outerHeight() - $view.innerHeight() + $breadHead.outerHeight()){
      if(!$pagetop.hasClass("appear")){
        $pagetop.addClass("appear");
      }
    }else{
      if($pagetop.hasClass("appear")){
        $pagetop.removeClass("appear");
      }
    }
  };
  $view.on("scroll", ViewTopScroll);
  
  // RESIZE
  $window.on("resize", function () {
    if (window.outerWidth < 829) {
      _isSP = true;
    } else {
      _isSP = false;
      $menu.removeClass("open");
      $html.removeClass("is-modal");
    }
  });
  
  $(".anchor").on("click", function () {
    const _$this = $(this);
    const href = _$this.attr("href");
    const _$target = $(href);
    
    if (_isSP) {
      $menu.removeClass("open");
      $html.removeClass("is-modal");
      $("html, body").stop().animate({scrollTop: _$target.offset().top}, 1500, "easeInOutQuart");
    } else {
      $view.stop().animate({scrollTop: _$target.offset().top - $main.offset().top}, 1500, "easeInOutQuart");
    }
    
    return false;
  });
  
  $body.addClass("loaded");
})();

const _jsonPath = "assets/api/";
let kyotoData = null;
let osakaData = null;
let shigaData = null;
let map;
let infoWindow;
let currentUserPosition;
let isGetCurrentPosition = false;
const kyotoRacetrack = { lat: 34.9070004, lng: 135.7219539 };

global.initMap = function () {
  __c__('initMap');
  // 34.9070004,135.7219539
  
  map = new google.maps.Map(document.getElementById("map"), {
    center: kyotoRacetrack,
    zoom: 12,
    mapId: 'DEMO_MAP_ID' // デモ用のMap ID
  });
  
  infoWindow = new google.maps.InfoWindow();
  
  getUserLocation();
}

function getUserLocation() {
  __c__('getUserLocation');
  //const statusDiv = document.getElementById("status");
  
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        currentUserPosition = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        //statusDiv.textContent = "現在地を取得しました。店舗情報を読み込んでいます...";
        
        map.setCenter(currentUserPosition);
        map.setZoom(13);
        
        new google.maps.Marker({
          position: currentUserPosition,
          map: map,
          title: "現在地",
          icon: {
            url: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
          },
        });
        isGetCurrentPosition = true;
        loadStoresAndCalculateDistances();
      },
      (error) => {
        __c__(error);
        
        currentUserPosition = {
          lat: kyotoRacetrack.lat,
          lng: kyotoRacetrack.lng,
        };
        
        map.setCenter(currentUserPosition);
        map.setZoom(13);
        
        new google.maps.Marker({
          position: currentUserPosition,
          map: map,
          title: "現在地",
          icon: {
            url: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
          },
        });
        
        loadStoresAndCalculateDistances();
      }
    );
  } else {
    //handleLocationError(false, statusDiv, map.getCenter());
    // handleLocationError(false, new HTMLElement(), map.getCenter());
  }
}

/**
 * 位置情報取得に失敗した場合のエラーハンドラ
 * @param {boolean} browserHasGeolocation - ブラウザがGeolocationをサポートしているか
 * @param {HTMLElement} statusDiv - ステータス表示用のDOM要素
 * @param {google.maps.LatLng} pos - エラー時に地図の中心とする位置
 */
function handleLocationError(browserHasGeolocation, statusDiv, pos) {
  __c__("handleLocationError");
  /*statusDiv.textContent = browserHasGeolocation
    ? "エラー: 位置情報サービスに失敗しました。許可設定を確認してください。"
    : "エラー: お使いのブラウザは位置情報サービスをサポートしていません。";*/
  alert(browserHasGeolocation
    ? "エラー: 位置情報サービスに失敗しました。許可設定を確認してください。"
    : "エラー: お使いのブラウザは位置情報サービスをサポートしていません。");
  
  map.setCenter(pos);
}

/**
 * store.jsonファイルを非同期で読み込む
 */
async function loadStoresAndCalculateDistances() {
  __c__("loadStoresAndCalculateDistances");
  try {
    const response = await fetch(_jsonPath + 'stores.json');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const stores = await response.json();
    
    kyotoData = stores.kyoto;
    osakaData = stores.osaka;
    shigaData = stores.shiga;
    
    const _kyoto = new SetStoreContents(document.querySelector('[data-store-content="kyoto1"]'), document.querySelector('[data-store-content="kyoto2"]'), "kyoto");
    _kyoto.setData(kyotoData);
    const _osaka = new SetStoreContents(document.querySelector('[data-store-content="osaka1"]'), document.querySelector('[data-store-content="osaka2"]'), "osaka");
    _osaka.setData(osakaData);
    const _shiga = new SetStoreContents(document.querySelector('[data-store-content="shiga1"]'), document.querySelector('[data-store-content="shiga2"]'), "shiga");
    _shiga.setData(shigaData);
    
    const alldata = kyotoData.concat(osakaData, shigaData);
    __c__(alldata);
    
    displayNearbyStores(alldata);
  } catch (error) {
    //document.getElementById("status").textContent = "店舗情報の読み込みに失敗しました。";
    alert("店舗情報の読み込みに失敗しました。");
    console.error("Fetch error:", error);
  }
}

/**
 * フィルタリングされた店舗を地図上にマーカーとして表示する
 * @param {Array<Object>} nearbyStores - 近くの店舗情報の配列
 */
function displayNearbyStores(nearbyStores) {
  nearbyStores.forEach(store => {
    const marker = new google.maps.Marker({
      position: {lat: store.lat, lng: store.lng},
      map: map,
      title: store.name,
    });
    
    marker.addListener("click", () => {
      const distanceInKm = store.distance ? (store.distance / 1000).toFixed(2) : null;
      const distanceHtml = distanceInKm ? `<p>現在地からの直線距離: 約${distanceInKm} km</p>` : "";
      const contentString = `
        <div style="font-family: sans-serif;">
          <h3>${store.name}</h3>
          <p><a href="https://www.google.com/maps/dir/?api=1&origin=${currentUserPosition.lat},${currentUserPosition.lng}&destination=${store.name}, ${store.address}&travelmode=walking" target="_blank">店舗までのルート</a></p>
          <p><a href="${store.url}" target="_blank">店舗詳細</a></p>
          ${distanceHtml}
        </div>
      `;
      infoWindow.setContent(contentString);
      infoWindow.open(map, marker);
    });
  });
}